import axios from 'axios';
import {
  API_RESPONSE,
  SOURCE_SYNC_URL,
  PREVIEW_SOURCE_SYNC_URL_LOCALHOST,
} from '../settings/shared/constants';
import { constructPreviewUrls } from '../settings/shared/commonMethods';

const isK8sEnv = () => localStorage.getItem('environmentType') === 'K8S';

const axiosCodeSync = axios.create({
  baseURL: isK8sEnv() ? SOURCE_SYNC_URL : PREVIEW_SOURCE_SYNC_URL_LOCALHOST,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
axiosCodeSync.interceptors.request.use(
  function (config) {
    const projectId = config.headers['project-id'] || config.headers['Project-Id'];

    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    if (projectId) {
      config.baseURL = isK8sEnv()
        ? constructPreviewUrls(SOURCE_SYNC_URL, projectId)
        : PREVIEW_SOURCE_SYNC_URL_LOCALHOST;
    } else {
      config.baseURL = isK8sEnv()
        ? SOURCE_SYNC_URL
        : PREVIEW_SOURCE_SYNC_URL_LOCALHOST;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosCodeSync.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    let resp = {
      errorMessage: error?.message + ' : ' + error.code,
      status: API_RESPONSE.FAILED,
    };
    return resp;
  }
);

export default axiosCodeSync;
